/**
 * macOS-style Confirm Dialog
 * Ersetzt native confirm() mit einem Design-konformen Dialog.
 */
export default function ConfirmDialog({ title, message, confirmLabel, danger, onConfirm, onCancel }) {
  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-card" style={{ maxWidth: 360, textAlign: 'center' }} onClick={e => e.stopPropagation()}>
        <h3 style={{ marginBottom: 8 }}>{title || 'Bestätigung'}</h3>
        {message && <p style={{ fontSize: 14, color: 'var(--color-text-secondary)', marginBottom: 20, lineHeight: 1.5 }}>{message}</p>}
        <div className="modal-actions" style={{ justifyContent: 'center' }}>
          <button className="btn btn-secondary btn-sm" onClick={onCancel}>Abbrechen</button>
          <button className={`btn btn-sm ${danger ? 'btn-danger' : 'btn-primary'}`} onClick={onConfirm} autoFocus>
            {confirmLabel || 'Bestätigen'}
          </button>
        </div>
      </div>
    </div>
  )
}
